/* eslint-disable no-use-before-define */
import * as ActionConstants from '../containers/IssuerActions/ActionConstants.js';
import { isObject } from 'util';
import { __MSGBOX__, __DATE__ } from '../containers/ActionIssuerComponents/ActionIssuerConstants.js';
import moment from 'moment';

const __TEXT__ = 'TEXT';
const __DROPDOWN__ = 'DROPDOWN';
const __COMMENTS__ = 'COMMENTS';
const __CURRENCY__ = 'CURRENCY';
const __TYPE_OF_NUMBER = 'number';

export function formatPhoneNumber(s) {
  const s2 = `${s}`.replace(/\D/g, '');
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
}

export function handlePrecision(amount, precision) {
  if (amount !== undefined && amount !== null) {
    const arr = `${amount}`.split('.');
    return arr.length > 1
      ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
      : `${amount <= 0 ? amount * -1 : amount}.00`;
  }
  return '--';
}

export function decamelize(string, separator) {
  separator = typeof separator === 'undefined' ? '_' : separator.toUpperCase();

  return (
    string.charAt(0).toUpperCase() +
    string
      .slice(1)
      .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
      .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
  );
}

export function numberWithCommas(amount) {
  amount = amount ? (Math.round(amount * 100) / 100).toFixed(2) : amount;
  return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0;
}

export function transformFinancialAdjustmentDataSubmit(nestedFieldSelectorData = {}, acquirerCode) {
  const financialAdjustment = {};
  let ledgerInputList = [];
  nestedFieldSelectorData.forEach((row) => {
    const ledgerDetail = row.name && row.name.split(':');
    ledgerInputList = ledgerInputList.concat({
      acquirerCode,
      amount: row.v1 ? preciseToDecimal(row.v1, 2) : preciseToDecimal(row.v2, 2),
      internalNotes: row.v3,
      ledgerAccountNumber: ledgerDetail && ledgerDetail[0],
      ledgerAdjustment: row.v1 ? 'DEBIT' : 'CREDIT',
    });
  });

  financialAdjustment.ledgerInputList = ledgerInputList;
  return financialAdjustment;
}

export function preciseToDecimal(value, upToDecimalPoint) {
  return (Math.round(value * 100) / 100).toFixed(upToDecimalPoint);
}

export function transformFinancialAdjustmentDataReview(adjustFinancialsData) {
  const result = {};

  let data = [];
  adjustFinancialsData.data.forEach((row, index) => {
    data = data.concat({
      seq_key: index,
      ledger: row.name,
      debit: row.v1 === undefined || row.v1 === '' ? '--' : preciseToDecimal(row.v1, 2),
      credit: row.v2 === undefined || row.v2 === '' ? '--' : preciseToDecimal(row.v2, 2),
      internalNote: row.v3 === undefined ? '--' : row.v3,
    });
  });
  result.data = data;
  result.config = adjustFinancialsData.config;
  return result;
}
/**
 * This method is used for fetching liability data and return to review Screen page.
 * @param {*} issuerActionData
 */
export function getLiabilityData(issuerActionData, disputeStageName, jsonHeadings, reasonCodeCategoryDesc) {
  if (issuerActionData !== undefined) {
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return (
        actionData.selectedActionIssuerId === ActionConstants.__UNABLETO_FULFILL_ACCEPT_LIABILITY_ID__ ||
        actionData.selectedActionIssuerId === ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ACCEPT_LIABILITY_ID__ ||
        actionData.selectedActionIssuerId === ActionConstants.__WRITEOFF_GOODWILL_ACCEPT_LIABILITY_ID__
      );
    });
    const jsonHeadingIndex = jsonHeadings.findIndex((dataColumn) => {
      return dataColumn.reviewScreenKey === 'liabilityInfo';
    });
    return (
      jsonHeadings &&
      jsonHeadingIndex !== -1 &&
      updateIndex !== -1 &&
      jsonHeadings[jsonHeadingIndex] &&
      setReviewData(
        disputeStageName,
        reasonCodeCategoryDesc,
        issuerActionData,
        updateIndex,
        jsonHeadings[jsonHeadingIndex],
      )
    );
  }
}

/**
 * This method is used for fetching liability data and return to submit data.
 * @param {*} issuerActionData
 */
export function getLiabilitySubmitData(issuerActionData, checkBoxStatus=[]) {
  if (issuerActionData !== undefined) {
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return (
        actionData.selectedActionIssuerId === ActionConstants.__UNABLETO_FULFILL_ACCEPT_LIABILITY_ID__ ||
        actionData.selectedActionIssuerId === ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ACCEPT_LIABILITY_ID__ ||
        actionData.selectedActionIssuerId === ActionConstants.__WRITEOFF_GOODWILL_ACCEPT_LIABILITY_ID__
      );
    });
    var liabilityInfo = null;
    var notes = issuerActionData[updateIndex].note;
    const utdrActionIndex = checkBoxStatus.findIndex(({selectedActionIssuerId})=> selectedActionIssuerId === ActionConstants.__UNABLE_TO_DEFEND_PURSUE_MERCH_MSG_ID__);
    const merchantAcceptLiability = utdrActionIndex !== -1 ? (checkBoxStatus[utdrActionIndex]?.status[4] || false) : undefined;

    const stageConfigId =
      issuerActionData[updateIndex] === undefined ||
      (issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption[0] === undefined)
        ? 0
        : issuerActionData[updateIndex].selectedOption[0].value;
    if (updateIndex !== -1) {
      liabilityInfo = {
        comment: notes,
        liabilityAccepted: true,
        stageConfigId,
        merchantAcceptLiability
      };
    }
    return liabilityInfo;
  }
}

/**
 * This method is used for fetching write off reason data and return to review Screen page.
 * @param {*} issuerActionData
 */
export function getWriteOffReason(issuerActionData) {
  if (issuerActionData !== undefined) {
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return actionData.selectedActionIssuerId === ActionConstants.__WRITEOFF_GOODWILL_WRITE_OFF_REASON_ID__;
    });
    const data = [
      {
        title: 'Explanation',
        desc: issuerActionData[updateIndex] === undefined ? '' : issuerActionData[updateIndex].note,
      },
    ];
    return data;
  }
}

/**
 * This method is used for fetching write off reason data and return to review Screen page.
 * @param {*} issuerActionData
 */
export function getWriteOffReasonSubmitData(issuerActionData) {
  if (issuerActionData !== undefined) {
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return actionData.selectedActionIssuerId === ActionConstants.__WRITEOFF_GOODWILL_WRITE_OFF_REASON_ID__;
    });
    return issuerActionData[updateIndex] === undefined ? null : issuerActionData[updateIndex].note;
  }
}

// Get questionare data for submit response
export function getQuestionSubmitData(
  issuerActionData,
  issuerImageData,
  cardBrand,
  visaQuestionnaireData,
  disputeStageName,
  actionViewCode,
  disputeCurrencyCode,
  merchantCurrencyCode,
  transactionDate,
) {
  const updateIndex = issuerActionData.findIndex((actionData) => {
    return actionData.selectedActionIssuerId === ActionConstants.__RESPOND_TO_ISSUER_QUESTIONNAIRE_ID__;
  });
  const documentsForIssuer = formatImageDataForSubmit(issuerImageData);
  const issuerDocumentsProvided = documentsForIssuer.length > 0 ? true : false;
  const messageText = issuerActionData[updateIndex] === undefined ? '' : issuerActionData[updateIndex].note.trim();
  const stageConfigId =
    issuerActionData[updateIndex] === undefined ||
    (issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption[0] === undefined)
      ? 0
      : issuerActionData[updateIndex].selectedOption[0].value;
  const matchedDoc = issuerImageData.find(e =>
    e.imageData.some(doc => doc.documentType === 'Docs to the Issuer-no conversion')
  );
  let docId, documentType, documentName;
  if (matchedDoc) {
    // Find the first document that matches the required type
    const firstDoc = matchedDoc.imageData.find(doc => doc.documentType === 'Docs to the Issuer-no conversion');
    if (firstDoc) {
      docId = firstDoc.docId;
      documentType = firstDoc.documentType;
      documentName = firstDoc.documentName;
    }
  }
  const responseReasonCode =
    issuerActionData[updateIndex] === undefined ||
    (issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption[1] === undefined)
      ? undefined
      : actionViewCode !== 'PCF'
      ? issuerActionData[updateIndex].selectedOption[1].value
      : undefined;
  const visaQuestionnaire = cardBrand === 'VI' && disputeStageName === 'Chargeback' ? visaQuestionnaireData : undefined;
  const selectedOption =
    issuerActionData[updateIndex] === undefined
      ? ''
      : issuerActionData[updateIndex].selectedOption[0].text.toLowerCase();
  const pcfQuestionnaire =
    actionViewCode === 'PCF'
      ? setCasePursueDataForSubmit(
          issuerActionData,
          updateIndex,
          merchantCurrencyCode,
          disputeCurrencyCode,
          transactionDate,
          selectedOption,
          cardBrand,
        )
      : undefined;
  // eslint-disable-next-line no-unused-vars
  const acceptedAmount =
    selectedOption === __CREATE_GOOD_FATIH_REQUEST__ &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].text &&
    issuerActionData[updateIndex].text.length === 1
      ? issuerActionData[updateIndex].text[0]
      : issuerActionData[updateIndex] === undefined
      ? undefined
      : !pcfQuestionnaire &&
        cardBrand === 'VI' &&
        (disputeStageName === 'Incoming Pre-Arbitration' || disputeStageName === 'Incoming Pre-Compliance')
      ? issuerActionData[updateIndex].text
      : undefined;
  const acceptedAmountString =
    selectedOption === __CREATE_GOOD_FATIH_REQUEST__ &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].text &&
    issuerActionData[updateIndex].text.length === 1
      ? issuerActionData[updateIndex].text[0]
      : issuerActionData[updateIndex] === undefined
      ? undefined
      : !pcfQuestionnaire &&
        cardBrand === 'VI' &&
        (disputeStageName === 'Incoming Pre-Arbitration' || disputeStageName === 'Incoming Pre-Compliance')
      ? issuerActionData[updateIndex].text.length === 0
        ? ''
        : JSON.stringify(issuerActionData[updateIndex].text[0])
      : undefined;

  const representmentQuestion = {
    documentsForIssuer,
    issuerDocumentsProvided,
    messageText,
    docId,
    documentName,
    documentType,
  };
  if (pcfQuestionnaire) {
    representmentQuestion.pcfQuestionnaire = pcfQuestionnaire;
  }
  /*
  **Changed from [] to ""
  **Removed as the required payload format was a String
  if (acceptedAmount) {
    representmentQuestion.acceptedAmount = acceptedAmount;
  }*/
  if (acceptedAmountString && typeof acceptedAmountString !== __TYPE_OF_NUMBER) {
    representmentQuestion.acceptedAmount = acceptedAmountString.replace(/"/g, '');
  }
  if (responseReasonCode) {
    representmentQuestion.responseReasonCode = responseReasonCode;
  }
  if (actionViewCode === 'RTI' && visaQuestionnaire) {
    representmentQuestion.visaQuestionnaire = visaQuestionnaire;
    representmentQuestion.messageText =
      visaQuestionnaire.response &&
      visaQuestionnaire.response.resonNotAcceptLiability &&
      visaQuestionnaire.response.resonNotAcceptLiability.value
        ? visaQuestionnaire.response.resonNotAcceptLiability.value
        : '';
  } else {
    representmentQuestion.stageConfigId = stageConfigId;
  }
  if (visaQuestionnaire && (visaQuestionnaire.response.ce03AlocState || visaQuestionnaire.response.ce03ColbState)) {
    let stateKeyMapFormat = representmentQuestion.visaQuestionnaire.response.ce03AlocState
      ? representmentQuestion.visaQuestionnaire.response.ce03AlocState.value
      : representmentQuestion.visaQuestionnaire.response.ce03ColbState.value;
    stateKeyMapFormat =
      stateKeyMapFormat &&
      typeof stateKeyMapFormat !== __TYPE_OF_NUMBER &&
      stateKeyMapFormat.toUpperCase().replace(1, ''); /*NOTE : Formatted for Duplicated Keys */
    representmentQuestion.visaQuestionnaire.response.ce03AlocState
      ? (representmentQuestion.visaQuestionnaire.response.ce03AlocState.value = stateKeyMapFormat)
      : (representmentQuestion.visaQuestionnaire.response.ce03ColbState.value = stateKeyMapFormat);
  }
  return representmentQuestion;
}

const __CREATE_GOOD_FATIH_REQUEST__ = 'create good faith request';
const __INITIATE_PRE_ARBITRATION__ = 'initate pre-arbitration';
const __FILE_COMPLIANCE__ = 'file compliance';
const __INITIATE_PRE_COMPLIANCE__ = 'initiate pre-compliance';
const __OTHER_VIOLATION_CODE__ = 'C050';
const __ADDITIONAL_INFO__ = 'Additional Information on Rules Violated (required)';
const __FIRST_DATE__ = '0_date';
const __SECOND_DATE__ = '1_date';
const __THIRD_DATE__ = '2_date';
const __FOURTH_DATE__ = '3_date';
const __DATE_FORMAT__ = 'YYYY-MM-DD';
const __REPRESENTMENT_QUESTION__ = 'representmentQuestion';

const __DEFAULT_CURRENCY__ = 'USD';
/**
 * set case pursue data for submit api.
 * @param {*} issuerActionData
 * @param {*} updateIndex
 * @param {*} merchantCurrencyCode
 * @param {*} disputeCurrencyCode
 * @param {*} transactionDate
 */
function setCasePursueDataForSubmit(
  issuerActionData,
  updateIndex,
  merchantCurrencyCode,
  disputeCurrencyCode,
  transactionDate,
  selectedOption,
  cardBrand,
) {
  let dateValue = null;
  switch (cardBrand) {
    case 'VI':
      dateValue = issuerActionData[updateIndex].date && [__THIRD_DATE__]
        ? moment(issuerActionData[updateIndex].date[__THIRD_DATE__]).format(__DATE_FORMAT__)
        : undefined;
      break;
    case 'MC':
      dateValue =
        issuerActionData[updateIndex].date && issuerActionData[updateIndex].date[__FOURTH_DATE__]
          ? moment(issuerActionData[updateIndex].date[__FOURTH_DATE__]).format(__DATE_FORMAT__)
          : undefined;
      break;
    default:
      dateValue =
        issuerActionData[updateIndex].date && issuerActionData[updateIndex].date[__FIRST_DATE__]
          ? moment(issuerActionData[updateIndex].date[__FIRST_DATE__]).format(__DATE_FORMAT__)
          : undefined;
      break;
  }

  const goodFaithDisputeStageId =
    issuerActionData[updateIndex] === undefined ||
    (issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption[1] === undefined)
      ? undefined
      : selectedOption === __CREATE_GOOD_FATIH_REQUEST__
      ? issuerActionData[updateIndex].selectedOption[1].value
      : undefined;
  const violationCode =
    issuerActionData[updateIndex] === undefined ||
    (issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption[1] === undefined)
      ? undefined
      : selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__
      ? issuerActionData[updateIndex].selectedOption[1].value
      : undefined;
  const goodFaithResponseDate =
    selectedOption === __CREATE_GOOD_FATIH_REQUEST__ &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].date
      ? dateValue
      : undefined;
  const responseDueDate =
    selectedOption === __INITIATE_PRE_ARBITRATION__ &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].date
      ? moment(issuerActionData[updateIndex].date[__FIRST_DATE__]).format(__DATE_FORMAT__)
      : undefined;
  const violationDate =
    (selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__) &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].date
      ? moment(issuerActionData[updateIndex].date[__FIRST_DATE__]).format(__DATE_FORMAT__)
      : undefined;
  const violationDiscoveryDate =
    (selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__) &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].date
      ? moment(issuerActionData[updateIndex].date[__SECOND_DATE__]).format(__DATE_FORMAT__)
      : undefined;
  const creditDate =
    (selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__) &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].date
      ? moment(issuerActionData[updateIndex].date[__THIRD_DATE__]).format(__DATE_FORMAT__)
      : undefined;
  const financialLossOccured =
    (selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__) &&
    issuerActionData &&
    issuerActionData[updateIndex]
      ? issuerActionData[updateIndex].isFinancialLossOccured
      : undefined;
  const financialLossExp =
    (selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__) &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    financialLossOccured
      ? issuerActionData[updateIndex].financialLossExp.length > 0
        ? issuerActionData[updateIndex].financialLossExp
        : '--'
      : '';
  const fromCurrencyCodeDesc = merchantCurrencyCode ? merchantCurrencyCode : __DEFAULT_CURRENCY__;
  const filingAmount =
    selectedOption !== __CREATE_GOOD_FATIH_REQUEST__ &&
    issuerActionData &&
    issuerActionData[updateIndex] &&
    issuerActionData[updateIndex].text &&
    issuerActionData[updateIndex].text.length > 1
      ? issuerActionData[updateIndex].text[1]
      : undefined;
  const toCurrencyCodeDesc = disputeCurrencyCode ? disputeCurrencyCode : __DEFAULT_CURRENCY__;
  const additionalInfo =
    (selectedOption === __FILE_COMPLIANCE__ || selectedOption === __INITIATE_PRE_COMPLIANCE__) &&
    violationCode === __OTHER_VIOLATION_CODE__ &&
    issuerActionData[updateIndex].inputText
      ? issuerActionData[updateIndex].inputText[__ADDITIONAL_INFO__]
      : undefined;

  const pcfQuestionnaire = {
    filingAmount,
    financialLossOccured,
    financialLossExp,
    fromCurrencyCodeDesc,
    goodFaithDisputeStageId,
    goodFaithResponseDate,
    responseDueDate,
    toCurrencyCodeDesc,
    transactionDate,
    violationCode,
    violationDate,
    violationDiscoveryDate,
    creditDate,
    additionalInfo,
  };
  return pcfQuestionnaire;
}

// get questionare data for review
export function getQuestionnaireReviewData(
  issuerActionData,
  disputeStageName,
  jsonHeadings,
  reasonCodeCategoryDesc,
  representmentAmount,
) {
  if (issuerActionData !== undefined) {
    const jsonHeadingIndex = jsonHeadings.findIndex((dataColumn) => {
      return dataColumn.reviewScreenKey === __REPRESENTMENT_QUESTION__;
    });
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return actionData.selectedActionIssuerId === ActionConstants.__RESPOND_TO_ISSUER_QUESTIONNAIRE_ID__;
    });
    return (
      jsonHeadings &&
      jsonHeadingIndex !== -1 &&
      updateIndex !== -1 &&
      jsonHeadings[jsonHeadingIndex] &&
      setReviewData(
        disputeStageName,
        reasonCodeCategoryDesc,
        issuerActionData,
        updateIndex,
        jsonHeadings[jsonHeadingIndex],
        representmentAmount,
      )
    );
  }
}

function setReviewData(
  disputeStageName,
  reasonCodeCategoryDesc,
  issuerActionData,
  updateIndex,
  jsonHeadings,
  representmentAmount,
) {
  var data = [];
  let dataColumns = jsonHeadings.dataColumns;
  let selectedOptions = issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption;
  let dropDownIndex = -1;
  let currencyIndex = -1;
  let dateIndex = -1;
  let sameLineArray = [];
  dataColumns.map((dataColumn) => {
    if (dataColumn.stage) {
      dataColumn = dataColumn.stage.findIndex((item) => item === disputeStageName) !== -1 ? dataColumn : undefined;
      if (dataColumn && dataColumn.disputeType && reasonCodeCategoryDesc) {
        dataColumn = dataColumn.disputeType === reasonCodeCategoryDesc ? dataColumn : undefined;
      }
    }
    if (dataColumn) {
      let showQuesCurrency = issuerActionData[updateIndex].showQuesCurrency || dataColumn.selectedItem ? true : false;
      dateIndex = dataColumn.displayType === __DATE__ ? dateIndex + 1 : dateIndex;
      ({ dataColumn, showQuesCurrency } = setCasePursueFileData(dataColumn, selectedOptions, showQuesCurrency));
      var tempData;
      if (dataColumn) {
        dropDownIndex = dataColumn.displayType === __DROPDOWN__ ? dropDownIndex + 1 : dropDownIndex;
        currencyIndex = dataColumn.displayType === __CURRENCY__ ? currencyIndex + 1 : currencyIndex;
        switch (dataColumn.displayType) {
          case __TEXT__:
            if (sameLineArray.length > 0 && sameLineArray.findIndex((item) => item.displayType === __TEXT__) === -1) {
              data.push(sameLineArray);
              sameLineArray = [];
            }
            tempData = {
              title: dataColumn.name,
              desc:
                issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].inputText
                  ? issuerActionData[updateIndex].inputText[dataColumn.name]
                  : '',
            };
            break;
          case __CURRENCY__:
            if (
              sameLineArray.length > 0 &&
              sameLineArray.findIndex((item) => item.displayType === __CURRENCY__) === -1
            ) {
              data.push(sameLineArray);
              sameLineArray = [];
            }
            if (showQuesCurrency) {
              tempData = {
                title: dataColumn.name,
                desc:
                  issuerActionData[updateIndex] !== undefined &&
                  issuerActionData[updateIndex].currencyCode &&
                  issuerActionData[updateIndex].currencyCode[currencyIndex]
                    ? (representmentAmount && representmentAmount[currencyIndex]
                        ? preciseToDecimal(representmentAmount[currencyIndex], 2)
                        : 0) +
                      ' ' +
                      issuerActionData[updateIndex].currencyCode[currencyIndex]
                    : representmentAmount && representmentAmount[currencyIndex]
                    ? dataColumn.isMerchantCurrencyCode && issuerActionData[updateIndex].currencyCode[0]
                      ? preciseToDecimal(representmentAmount[currencyIndex], 2) +
                        ' ' +
                        issuerActionData[updateIndex].currencyCode[0]
                      : preciseToDecimal(representmentAmount[currencyIndex], 2) + ' USD'
                    : 0,
              };
              if (dataColumn.sameLine) {
                tempData.displayType = __CURRENCY__;
                sameLineArray.push(tempData);
              }
            }
            break;
          case __DROPDOWN__:
            if (
              sameLineArray.length > 0 &&
              sameLineArray.findIndex((item) => item.displayType === __DROPDOWN__) === -1
            ) {
              data.push(sameLineArray);
              sameLineArray = [];
            }
            tempData = {
              title: dataColumn.name,
              desc: selectedOptions && selectedOptions[dropDownIndex] ? selectedOptions[dropDownIndex].text : '',
            };
            break;
          case __COMMENTS__:
            if (
              sameLineArray.length > 0 &&
              sameLineArray.findIndex((item) => item.displayType === __COMMENTS__) === -1
            ) {
              data.push(sameLineArray);
              sameLineArray = [];
            }
            tempData = {
              title: dataColumn.name,
              desc:
                issuerActionData[updateIndex] === undefined
                  ? ''
                  : dataColumn.id === 'financialLossExp'
                  ? issuerActionData[updateIndex].financialLossExp.length > 0
                    ? issuerActionData[updateIndex].financialLossExp
                    : '--'
                  : issuerActionData[updateIndex].note,
            };
            break;
          case __DATE__:
            if (sameLineArray.length > 0 && sameLineArray.findIndex((item) => item.displayType === __DATE__) === -1) {
              data.push(sameLineArray);
              sameLineArray = [];
            }

            if (dataColumn.id === 'creditDatePCF') {
              if (
                issuerActionData &&
                issuerActionData[updateIndex].selectedOption &&
                issuerActionData[updateIndex].selectedOption[1] &&
                dataColumn.bindWithValue === issuerActionData[updateIndex].selectedOption[1].value
              ) {
                tempData = {
                  title: dataColumn.name,
                  desc:
                    issuerActionData && issuerActionData[updateIndex] && issuerActionData[updateIndex].date
                      ? moment(issuerActionData[updateIndex].date[dateIndex + '_date']).format('MMM DD, YYYY')
                      : '',
                };
              }
            } else {
              tempData = {
                title: dataColumn.name,
                desc:
                  issuerActionData && issuerActionData[updateIndex] && issuerActionData[updateIndex].date
                    ? moment(issuerActionData[updateIndex].date[dateIndex + '_date']).format('MMM DD, YYYY')
                    : '',
              };
            }

            if (dataColumn.sameLine) {
              tempData.displayType = __DATE__;
              sameLineArray.push(tempData);
            }
            break;
          case __MSGBOX__:
            if (sameLineArray.length > 0 && sameLineArray.findIndex((item) => item.displayType === __MSGBOX__) === -1) {
              data.push(sameLineArray);
              sameLineArray = [];
            }
            tempData = {
              title: dataColumn.name,
              desc: issuerActionData && issuerActionData[updateIndex].isFinancialLossOccured ? 'Yes' : 'No',
            };
            break;
        }
        // eslint-disable-next-line no-unused-expressions
        tempData && sameLineArray.length === 0 && data.push(tempData);
      }
    }
  });

  return data;
}

function setCasePursueFileData(dataColumn, selectedOptions, showQuesCurrency) {
  let isDataColumnDefined = false;
  if (dataColumn.selectedItem) {
    for (let i = 0; i < selectedOptions.length; i++) {
      if (
        selectedOptions &&
        selectedOptions[i] &&
        dataColumn.selectedItem.findIndex((item) => item === selectedOptions[i].text.trim().toLowerCase()) !== -1
          ? dataColumn
          : undefined
      ) {
        isDataColumnDefined = true;
      }
    }
    dataColumn = isDataColumnDefined ? dataColumn : undefined;
    showQuesCurrency = isDataColumnDefined && showQuesCurrency ? true : false;
  }
  return { dataColumn, showQuesCurrency };
}

export function getCloseCaseData(issuerActionData) {
  if (issuerActionData !== undefined) {
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return actionData.selectedActionIssuerId === 26;
    });
    const data = [
      {
        title: 'Explanation Type',
        desc:
          issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption !== null
            ? issuerActionData[updateIndex].selectedOption.text
            : '',
      },
      {
        title: 'Explanation',
        desc: issuerActionData[updateIndex] === undefined ? '' : issuerActionData[updateIndex].note,
      },
    ];
    return data;
  }
}

// Close case data for submitcase data
export function getCloseCaseSubmitData(issuerActionData) {
  if (issuerActionData !== undefined) {
    const updateIndex = issuerActionData.findIndex((actionData) => {
      return actionData.selectedActionIssuerId === 26;
    });
    const data = {
      comment: {
        externalComment:
          issuerActionData[updateIndex] !== undefined && issuerActionData[updateIndex].selectedOption !== null
            ? issuerActionData[updateIndex].selectedOption.value
            : null,
        commentText: issuerActionData[updateIndex] === undefined ? null : issuerActionData[updateIndex].note,
      },
    };

    return data;
  }
}

// For Close Case (id 26) the checkboxes (in order) are:
//   index 0 -> Adjust Financials
//   index 1 -> Case Ruling (Record Case Ruling)
export function getRecordCaseRulingSubmitData(checkBoxStatus = []) {
  const closeCaseCheckBoxIndex = checkBoxStatus.findIndex(
    ({ selectedActionIssuerId }) => selectedActionIssuerId === 26
  );
  return closeCaseCheckBoxIndex !== -1
    ? (checkBoxStatus[closeCaseCheckBoxIndex]?.status?.[1] || false)
    : false;
}
// Get issuer image data for review data
export function getIssuerImageData(issuerImageData) {
  const selectedPages = issuerImageData === undefined ? [] : issuerImageData.selectedPages;
  let pageList = [];
  if (selectedPages !== undefined) {
    const values = Object.values(selectedPages);
    let imageIndex = 0;
    // eslint-disable-next-line no-unused-vars
    for (const imageArray of values) {
      imageArray.map((image) => {
        pageList = pageList.concat({ pageId: imageIndex, pageContent: image.pageContent });
        imageIndex += 1;
      });
    }
  }
  return pageList;
}
// Get merchant image data for review data
export function getMerchantImageData(merchantImageData) {
  const selectedPages = merchantImageData === undefined ? [] : merchantImageData.selectedPages;
  let pageList = [];
  if (selectedPages !== undefined) {
    const values = Object.values(selectedPages);
    let imageIndex = 0;
    // eslint-disable-next-line no-unused-vars
    for (const imageArray of values) {
      imageArray.map((image) => {
        pageList = pageList.concat({ pageId: imageIndex, pageContent: image.pageContent });
        imageIndex += 1;
      });
    }
  }
  return pageList;
}
/**
 * Data for merchant on submit to issuer
 */
export function getMerchantMessageSubmitData(merchantMessage, merchantImageData) {
  const updatedMerchantMessage = merchantMessage;
  const documentsForMerchant = formatImageDataForSubmit(merchantImageData);
  let merchantDocumentsProvided = documentsForMerchant.length > 0 ? true : false;
  updatedMerchantMessage.documentsForMerchant = documentsForMerchant;
  updatedMerchantMessage.merchantDocumentsProvided = merchantDocumentsProvided;
  return updatedMerchantMessage;
}

export function formatImageDataForSubmit(rawImageData) {
  let allPagesForReview = [];
  rawImageData.forEach((page) => {
    allPagesForReview = allPagesForReview.concat(page.imageData);
  });

  allPagesForReview = allPagesForReview.sort((a, b) => (a.addedWhen > b.addedWhen ? 1 : -1));

  allPagesForReview = allPagesForReview.map((page) => {
    return {
      base64EncodedImage: page.pageContent,
      imageFormat: 'png',
    };
  });
  return allPagesForReview;
}

export function formatImageDataForReview(rawImageData) {
  let allPagesForReview = [];
  rawImageData.forEach((page) => {
    allPagesForReview = allPagesForReview.concat(page.imageData);
  });

  allPagesForReview = allPagesForReview.sort((a, b) => (a.addedWhen > b.addedWhen ? 1 : -1));

  return allPagesForReview;
}

export function getFormattedSchemeData(data) {
  let acquirer = data.acquirerCode;
  delete data['acquirerCode'];
  let dataClone = { ...data };

  // For Prosa Domestic
  if (acquirer === 'MXP' || acquirer === 'EMD') {
    return data;
  }

  if (data.cardBrandCode === 'DI') {
    return data;
  }

  if (data.cardBrandCode === 'VI' && data.fileTypeInd === 'b2') {
    let transactionComponentsFields = {};
    transactionComponentsFields['cardBrandCode'] = 'VI';
    transactionComponentsFields['fileTypeInd'] = 'b2';
    data.fields.transactionComponents.map((item, index) => {
      return item.forEach((field) => {
        transactionComponentsFields[`${index}__${[field.fieldName]}`] = field.fieldValue;
      });
    });
    dataClone = transactionComponentsFields;
  }
  if (data.cardBrandCode === 'VI' && data.fileTypeInd === 'd5') {
    let fields = {};
    fields['cardBrandCode'] = 'VI';
    fields['fileTypeInd'] = 'd5';
    fields = normalizeData(data.fields);
    dataClone = fields;
  }

  if (data.cardBrandCode === 'MC') {
    let fields = {};
    fields['cardBrandCode'] = 'MC';
    let dataFields = {};
    if (Array.isArray(data.fields)) {
      data.fields.forEach((field) => {
        dataFields[field.fieldName] = field.fieldValue;
      });
    } else {
      dataFields = data.fields;
    }

    fields = normalizeData(dataFields);
    dataClone = fields;
  }

  if (data.cardBrandCode === 'AX') {
    return data;
  }

  if (data.cardBrandCode === 'PR') {
    return data;
  }

  if (data.cardBrandCode === 'PL') {
    return data;
  }

  if (data.cardBrandCode === 'CN') {
    return data;
  }
  return dataClone;
}

export function getDataColumnsForScheme(data) {
  let dataColumnsfromApiData = [];
  if (data.cardBrandCode === 'VI' && data.fileTypeInd === 'b2') {
    if (data !== undefined) {
      // eslint-disable-next-line no-unused-vars
      for (let fieldKey of Object.keys(data)) {
        var str = fieldKey;
        var res = str && str.split('__');
        const displayName = res[1] !== undefined ? decamelize(res[1], ' ') : decamelize(fieldKey, ' ');
        dataColumnsfromApiData = dataColumnsfromApiData.concat({
          defaultIsVisible: true,
          isDefault: true,
          name: displayName,
          displayType: 'STRING',
          columnKey: fieldKey,
          columnId: fieldKey,
        });
      }
    }
  }
  if (data !== undefined && data.fileTypeInd !== 'b2') {
    // eslint-disable-next-line no-unused-vars
    for (let fieldKey of Object.keys(data)) {
      const displayName = decamelize(fieldKey, ' ');
      dataColumnsfromApiData = dataColumnsfromApiData.concat({
        defaultIsVisible: true,
        isDefault: true,
        name: displayName,
        displayType: 'STRING',
        columnKey: fieldKey,
        columnId: fieldKey,
      });
    }
  }
  return dataColumnsfromApiData.sort((ele1, ele2) => {
    const item1 = ele1.name.toLowerCase();
    const item2 = ele2.name.toLowerCase();
    if (item1 < item2) return -1;
    if (item1 > item2) return 1;
    return 0;
  });
}

export function normalizeData(dataObject) {
  let formattedData = {};
  function formatToSingleValue(dataObject, parentKey) {
    // eslint-disable-next-line no-unused-vars
    for (let outerKey of Object.keys(dataObject)) {
      if (isObject(dataObject[outerKey])) {
        formatToSingleValue(dataObject[outerKey], parentKey);
      } else {
        // Check if property is array and do not include it in response.
        if (!Array.isArray(dataObject)) {
          formattedData[outerKey] = dataObject[outerKey];
        }
      }
    }
  }

  formatToSingleValue(dataObject);
  return formattedData;
}

export function getIssuerDocData(issuerImageData) {
  const issuerDocData = {};
  const documentsForIssuer = formatImageDataForSubmit(issuerImageData);
  let issuerDocumentsProvided = documentsForIssuer.length > 0 ? true : false;
  issuerDocData.documentsForIssuer = documentsForIssuer;
  issuerDocData.issuerDocumentsProvided = issuerDocumentsProvided;
  const documentTypes = issuerImageData.map((issuer) => (issuer.imageData && issuer.imageData[0] ? issuer.imageData[0].documentType : undefined)).filter((type) => type !== undefined);
  issuerDocData.documentTypes = documentTypes;
  const docsToIssuerNoConversionExists = documentTypes.includes('Docs to the Issuer-no conversion');
  if (docsToIssuerNoConversionExists) {
  const docType = issuerImageData.find((e) => e.imageData && e.imageData[0]?.documentType === 'Docs to the Issuer-no conversion');
  if (docType && docType.imageData && docType.imageData[0]) {
    issuerDocData.docType = docType.imageData[0].documentType;
    issuerDocData.documentName = docType.imageData[0].documentName;
  }
}
  return issuerDocData;
}

export default {
  formatPhoneNumber,
  numberWithCommas,
  transformFinancialAdjustmentDataSubmit,
  transformFinancialAdjustmentDataReview,
  getLiabilityData,
  getWriteOffReason,
  getQuestionSubmitData,
  getQuestionnaireReviewData,
  getIssuerImageData,
  getMerchantImageData,
  getMerchantMessageSubmitData,
  getCloseCaseSubmitData,
  getWriteOffReasonSubmitData,
  getLiabilitySubmitData,
  formatImageDataForReview,
  handlePrecision,
  decamelize,
  getDataColumnsForScheme,
  getFormattedSchemeData,
  normalizeData,
  getIssuerDocData,
};